//css
import './MessageTemplate.scss';
import { ActiveMessagesFeatures } from '../../growth/activeMessages/ActiveMessagesFeatures';
// Controllers
import { CreateMessageTemplateSidebarController } from './createMessageTemplateSidebar/CreateMessageTemplateSidebarController';
import { MessageTemplateStatus } from './models/MessageTemplateStatus';
// Views
import CreateMessageTemplateSidebarView from './createMessageTemplateSidebar/CreateMessageTemplateSidebarView.html';
import angular from 'angular';
import { ChannelsNames } from '../../channels/Channels';
const MAX_TEMPLATE_PAGE = 20; // Number of message templates per page
export const MessageTemplateDeleted = 'MessageTemplateDeleted';
export class MessageTemplateController {
    static $inject = ['$document', 'application', 'MessageTemplateSegmentService', 'LoadingService', 'SidebarContentService', 'MessageTemplateService', '$translate', '$rootScope', 'BlipToastService', 'ModalService', '$timeout', 'MessageTemplateUtil', 'ChannelsService'];
    constructor($document, application, MessageTemplateSegmentService, LoadingService, SidebarContentService, MessageTemplateService, $translate, $rootScope, BlipToastService, ModalService, $timeout, MessageTemplateUtil, ChannelsService) {
        'ngInject';
        this.$document = $document;
        this.application = application;
        this.MessageTemplateSegmentService = MessageTemplateSegmentService;
        this.LoadingService = LoadingService;
        this.SidebarContentService = SidebarContentService;
        this.MessageTemplateService = MessageTemplateService;
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.BlipToastService = BlipToastService;
        this.ModalService = ModalService;
        this.$timeout = $timeout;
        this.MessageTemplateUtil = MessageTemplateUtil;
        this.ChannelsService = ChannelsService;
        this.filteredTemplateName = [];
        this.filteredStatus = [];
        this.isCacheExpired = true;
        this.isRefreshOnCooldown = false;
    }
    async $onInit() {
        this.keypressHandler = (event) => {
            this.$timeout(() => this.readKeyPress(event));
        };
        this.$document.on('keypress', this.keypressHandler);
        this.MessageTemplateSegmentService.setApplication(this.application);
        this.canLoadMore = false;
        this.actualLimit = MAX_TEMPLATE_PAGE;
        this.isLoading = false;
        this.nextPageKey = undefined;
        this.messageTemplates = [];
        this.hasFilterActive = false;
        this.invalidTemplateNameFilter = false;
        this.statusOptions = Object.values(MessageTemplateStatus).map(this.getStatusOption.bind(this));
        this.enableLazyLoadingTemplates = await ActiveMessagesFeatures.isTemplatesLazyLoading();
        await this.ChannelsService.init(this.application);
        await this.loadTemplates(true);
        this.$rootScope.$on(MessageTemplateDeleted, this.loadTemplatesAfterAction.bind(this));
    }
    $onDestroy() {
        if (this.keypressHandler) {
            this.$document.off('keypress', this.keypressHandler);
            this.keypressHandler = undefined;
        }
    }
    getStatusOption(status) {
        return {
            value: status,
            label: this.$translate.instant(`messageTemplate.status.${status}`),
        };
    }
    async loadTemplates(resetFilter = false, filterTemplate, filterStatus, renewCache = false) {
        let templateFilter = undefined;
        let statusFilter = undefined;
        try {
            this.isLoading = true;
            this.LoadingService.startLoading(false);
            if (resetFilter) {
                this.nextPageKey = undefined;
                this.messageTemplates = [];
            }
            if (filterTemplate && filterTemplate.length > 0) {
                templateFilter = filterTemplate[0].item;
            }
            if (filterStatus && filterStatus.length > 0) {
                statusFilter = filterStatus[0].item;
            }
            const params = {
                templateName: templateFilter,
                status: statusFilter,
                renewCache: renewCache,
            };
            if (this.enableLazyLoadingTemplates) {
                params.limit = 400;
            }
            const whatsAppMessageTemplateList = await this.MessageTemplateService.getMessagesTemplatesEnriched(params);
            this.messageTemplates = [...this.messageTemplates, ...this.MessageTemplateUtil.convertToMessageTemplate(whatsAppMessageTemplateList.data)];
            this.canLoadMore = (this.messageTemplates.length > MAX_TEMPLATE_PAGE ? true : false);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
            this.LoadingService.stopLoading();
        }
    }
    onClickRefreshTemplates() {
        if (this.isRefreshOnCooldown) {
            return;
        }
        let isRenewCache = false;
        if (this.isCacheExpired) {
            isRenewCache = true;
            this.isCacheExpired = false;
            this.isRefreshOnCooldown = true;
            this.$timeout(() => {
                this.isCacheExpired = true;
                this.isRefreshOnCooldown = false;
            }, 60000);
        }
        this.filteredTemplateName = [];
        this.filteredStatus = [];
        this.loadTemplates(true, this.filteredTemplateName, this.filteredStatus, isRenewCache);
    }
    readKeyPress(event) {
        const key = event.key || String.fromCharCode(event.which || event.keyCode);
        if (key === 'r' || key === 'R') {
            event.preventDefault();
            this.onClickRefreshTemplates();
        }
    }
    loadMoreTemplates() {
        try {
            this.isLoading = true;
            this.LoadingService.startLoading(false);
            this.actualLimit += MAX_TEMPLATE_PAGE;
            this.canLoadMore = this.messageTemplates[this.actualLimit] ? true : false;
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
            this.LoadingService.stopLoading();
        }
    }
    isTemplateNameFilterInvalid() {
        this.invalidTemplateNameFilter = false;
        if (!this.filterTemplateName) {
            return false;
        }
        const regex = /^[a-z]([a-z0-9_])*$/g;
        const match = this.filterTemplateName.match(regex);
        if (!match) {
            this.invalidTemplateNameFilter = true;
            return true;
        }
        return false;
    }
    setTemplateFilter(templateName) {
        if (!templateName || this.isTemplateNameFilterInvalid()) {
            return;
        }
        this.clearTemplateNameFilter();
        this.filteredTemplateName = [];
        this.filteredTemplateName.push({
            text: templateName,
            item: templateName,
        });
        this.hasFilterActive = true;
        this.loadTemplates(true, this.filteredTemplateName, this.filteredStatus);
    }
    setStatusFilter(item) {
        if (!item) {
            return;
        }
        this.filteredStatus = [];
        const itemToAdd = this.statusOptions.find((status) => status.value == item);
        this.filteredStatus.push({
            text: itemToAdd.label,
            item: itemToAdd.value,
        });
        this.hasFilterActive = true;
        this.loadTemplates(true, this.filteredTemplateName, this.filteredStatus);
        this.clearStatusFilter();
    }
    removeFilter(isTemplateFilter, isStatusFilter) {
        if (isTemplateFilter) {
            this.filteredTemplateName = [];
        }
        else if (isStatusFilter) {
            this.filteredStatus = [];
        }
        if (!this.filteredTemplateName.length && !this.filteredStatus.length) {
            this.hasFilterActive = false;
        }
        this.loadTemplates(true, this.filteredTemplateName, this.filteredStatus);
    }
    isWhatsAppActive() {
        return this.ChannelsService.isChannelActive(ChannelsNames.WhatsApp);
    }
    clearStatusFilter() {
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.$rootScope.$broadcast('blip-select:clearInput');
        this.filterStatus = undefined;
    }
    clearTemplateNameFilter() {
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.filterTemplateName = undefined;
        this.isTemplateNameFilterInvalid();
    }
    async openNewMessageSidebar(messageTemplate) {
        const copyMessageTemplate = messageTemplate !== undefined ?
            angular.copy(messageTemplate) :
            { ...messageTemplate };
        if (Object.keys(copyMessageTemplate).length) {
            const copyMessage = await this.$translate('messageTemplate.copyTextMessage');
            copyMessageTemplate.name = `${messageTemplate.name}${copyMessage}`;
            this.MessageTemplateSegmentService.trackTemplateDuplicated();
        }
        if (!messageTemplate) {
            this.MessageTemplateSegmentService.trackAddButtonClicked();
        }
        this.MessageTemplateSegmentService.trackNewTemplateStarted();
        const sidebar = await this.SidebarContentService.showSidebar({
            controller: CreateMessageTemplateSidebarController,
            controllerAs: '$ctrl',
            template: CreateMessageTemplateSidebarView,
            appendToElement: this.$document[0].getElementById('message-template__main-content-area'),
            inputs: {
                messageTemplate: Object.keys(copyMessageTemplate).length ? copyMessageTemplate : this.createNewMessageTemplateObject(),
                messageTemplates: this.messageTemplates,
                $translate: this.$translate,
                MessageTemplateService: this.MessageTemplateService,
                BlipToastService: this.BlipToastService,
                ModalService: this.ModalService,
                MessageTemplateSegmentService: this.MessageTemplateSegmentService,
                onSaveMessageTemplate: this.loadTemplatesAfterAction.bind(this),
                application: this.application,
                type: Object.keys(copyMessageTemplate).length ? copyMessageTemplate.translations[0].type : 'default',
            },
        });
    }
    async loadTemplatesAfterAction() {
        this.filteredTemplateName = [];
        this.filteredStatus = [];
        this.loadTemplates(true, this.filteredTemplateName, this.filteredStatus);
    }
    createNewMessageTemplateObject() {
        const messageTemplate = {
            name: '',
            category: '',
            translations: [
                {
                    language: '',
                    text: '',
                    status: '',
                    qualityScore: {
                        date: 0,
                        score: '',
                    },
                },
            ],
        };
        return messageTemplate;
    }
}
MessageTemplateController.$inject = ['$document', 'application', 'MessageTemplateSegmentService', 'LoadingService', 'SidebarContentService', 'MessageTemplateService', '$translate', '$rootScope', 'BlipToastService', 'ModalService', 'MessageTemplateUtil', 'ChannelsService'];
